export default __webpack_public_path__ + "static/media/25.0e36522d.jpg";